import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TreeSelect from "@/components/TreeSelect.vue";
import { getAdviceList, getAdviceTypeList } from "@/api/personalCenter/suggestAngMsg";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "Suggest",
  components: {
    TreeSelect: TreeSelect
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        adviceType: "",
        depts: []
      },
      total: 0,
      typeList: [],
      departmentData: [],
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
    this.getAdviceTypeListFn();
    this.getDeptTreeData();
  },
  methods: {
    getAdviceType: function getAdviceType(value) {
      if (value == 1) {
        this.paramSearch.depts = [];
      }
    },
    setDeptDoubleMenu: function setDeptDoubleMenu(key, data) {
      this.paramSearch.depts = data.map(function (item) {
        return item.id;
      });
    },
    // 获取部门数据
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.departmentData = data.data;
        }
      }).catch(function (err) {});
    },
    // 获取建议类型
    getAdviceTypeListFn: function getAdviceTypeListFn() {
      var _this2 = this;

      getAdviceTypeList().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          var list = data.data || [];
          var arr = [];
          list.forEach(function (i) {
            for (var key in i) {
              arr.push({
                name: i[key],
                value: key
              });
            }
          });
          _this2.typeList = arr;
        }
      });
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this3 = this;

      this.loading = true;
      getAdviceList(this.paramSearch).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.list = data.data.records || [];
          _this3.total = data.data.total;
        }
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 默认页面数据
    searchFn: function searchFn() {
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    mapToArr: function mapToArr(arr, key) {
      var list = arr || [];
      return list.map(function (i) {
        return i[key];
      });
    }
  },
  watch: {},
  filters: {}
};